import React from 'react';
import { IFullUserDetails, ISystemUserTabOrdersQueryResult } from '../../graphql/schema/p4types';
import { ApolloQueryResult } from '@apollo/client';

export type IUserContext = {
  currentUser: IFullUserDetails;
  systemUserTabOrders: ISystemUserTabOrdersQueryResult;
  refetchTabOrders: (variables?: { systemUserId: any }) => Promise<ApolloQueryResult<any>>;
};

const UserContext = React.createContext({} as IUserContext);
export default UserContext;
